export function namesOf(values) {
    if (!Array.isArray(values)) return [];
    return values
        .map(value => (typeof value === 'string' ? value : value && value.name))
        .filter(Boolean);
}
